export { default as Message } from './message';
export { default as PresenceMessage } from './presence';
export { default as TextMessage } from './text';



// WEBPACK FOOTER //
// ./messages/index.js